import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import KYDSwitch from "../../ui/KYDSwitch";

interface SettingToggleProps {
  title: string;
  status: string | React.ReactNode;
  description?: string;
  isChecked: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  onChange: (checked: boolean) => void;
  colorScheme?: "blue" | "green" | "red" | "gray";
  statusColor?: string;
}

const SettingToggle = ({
  title,
  status,
  description,
  isChecked,
  isDisabled = false,
  isLoading = false,
  onChange,
  colorScheme = "green",
  statusColor = "gray.500",
}: SettingToggleProps) => {
  return (
    <Box
      bg="white"
      border="1px solid #E8E8E8"
      borderRadius="16px"
      p="16px"
      w="full"
      opacity={isLoading ? 0.6 : 1}
      transition="opacity 0.2s"
      position="relative"
    >
      <HStack w="full" justifyContent={"space-between"} alignItems={"center"}>
        <VStack alignItems={"flex-start"} gap={0} flexGrow={1} w="full">
          <Text fontWeight={"bold"} fontSize="md">
            {title}
          </Text>
          <Text fontSize="sm" color={statusColor}>
            {status}
          </Text>
          {description && (
            <Text fontSize="xs" color="gray.500" mt={1}>
              {description}
            </Text>
          )}
        </VStack>
        <Box position="relative">
          <KYDSwitch
            isChecked={isChecked}
            isDisabled={isDisabled || isLoading}
            onChange={(e) => onChange(e.target.checked)}
            colorScheme={colorScheme}
            size="lg"
          />
        </Box>
      </HStack>
    </Box>
  );
};

export default SettingToggle;
